import DrawText from "./drawText.container";

export default DrawText;
